var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileRewardsMx = function SvgMobileRewardsMx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 50"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.5,
    height: 48,
    x: 1,
    y: 1,
    stroke: "#8A0053",
    strokeWidth: 2,
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#8A0053",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M11.08 40.994h11.08"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A0053",
    fillRule: "evenodd",
    d: "m8.108 15.7 7.66-7.594a1.21 1.21 0 0 1 1.703 0l7.66 7.593c.47.466.47 1.222 0 1.688a1.21 1.21 0 0 1-1.703 0l-5.605-5.557v11.438h-2.407V11.83L9.81 17.387a1.21 1.21 0 0 1-1.702 0 1.186 1.186 0 0 1 0-1.688",
    clipRule: "evenodd"
  })));
};
export default SvgMobileRewardsMx;